export default __webpack_public_path__ + "static/media/arabic-icon.d2f9a327.png";